import { useNavigate } from 'react-router-dom';

function AdminPanel() {
    const navigate = useNavigate();

    const menuItems = [
        { label: '📺 Аніме', path: '/serials?page=1', color: '#4f46e5' },
        { label: '➕ Створити аніме', path: '/serials/edit', color: '#4686e5' },
        { label: '🏷️ Жанри', path: '/genres', color: '#f59e0b' },
        { label: '👥 Учасники', path: '/members', color: '#ebc012' },
        { label: '🏰 Франшизи', path: '/franchises?page=1', color: '#f65c5c' },
        { label: '➕ Створити франшизу', path: '/franchises/edit', color: '#f65c92' },
        { label: '📢 Розсилка (Telegram)', path: '/broadcast', color: '#51b42e' }
    ];

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
            padding: '20px',
            backgroundColor: '#f9fafb'
        }}>
            <h1 style={{ marginBottom: '30px', color: '#111827', fontFamily: 'sans-serif' }}>
                Панель керування
            </h1>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '20px',
                width: '100%',
                maxWidth: '600px'
            }}>
                {menuItems.map((item) => (
                    <button
                        key={item.path}
                        onClick={() => navigate(item.path)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '30px 20px',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: 'white',
                            backgroundColor: item.color,
                            border: 'none',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.2s, boxShadow 0.2s',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px)';
                            e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default AdminPanel;